export const contactOption = [
	{ label: "ID", key: "id", format: "string", dataPosition: "center", width: 1 },
	{
		label: "Plataforma",
		key: "contact.channel",
		format: "string",
		dataPosition: "center",
		width: 1,
		canFilter: true,
		canSort: true,
		canPrint: true,
		canExcel: true,
	},
	{ label: "Nombre", key: "name", format: "string", width: 1, canFilter: true, canSort: true, canPrint: true, canExcel: true },
	{
		label: "Teléfono",
		key: "phone",
		format: "phone",
		dataPosition: "center",
		width: 1,
		canFilter: true,
		canSort: true,
		canPrint: true,
		canExcel: true,
	},
	{
		label: "Correo",
		key: "email",
		format: "string",
		headerPosition: "left",
		dataPosition: "left",
		width: 16,
		canFilter: true,
		canSort: true,
		canPrint: true,
		canExcel: true,
	},
];

export const orderByOptions = [
	{
		key: "orderDirection",
		options: [
			{ key: "asc", text: "Ascendente", value: "asc" },
			{ key: "desc", text: "Descendente", value: "desc" },
		],
	},
];

export const orderByOptionsDetailed = [
	{ key: "chat.createdDate", text: "Fecha Entrada", value: "chat.createdDate" },
	{ key: "chat.closeDate", text: "Fecha Cierre", value: "chat.closeDate" },
	{ key: "chat.contact.name", text: "Contacto", value: "chat.contact.name" },
	{ key: "chat.user.fullName", text: "Usuario", value: "chat.user.fullName" },
	{ key: "chat.group.name", text: "Grupo", value: "chat.group.name" },
	{ key: "chattags.id", text: "ID", value: "chattags.id" },
];
